module.exports = __webpack_public_path__ + "static/media/bonnie.c928fb88.png";